'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabContent(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: 'tab-pane active' },
    children
  );
}

TabContent.propTypes = {
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react2.default.PropTypes.node), _react.PropTypes.node]).isRequired
};

TabContent.displayName = 'TabContent';

exports.default = TabContent;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-tabs/lib/components/tab-content/components/TabContent.component.js
// module id = 1357
// module chunks = 1